// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelStyle{
    font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; 
    font-size: 14px; 
    padding-right: 5px;
}

.inputDate{
    width:140px; 
    border-radius:5px;
    border: 1px solid teal; 
    height: 30px; color: black;
    font-size: 14px;
}
.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}

.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 10px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 10px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}
/* 
.first td:nth-child(1) {
    color: teal;
} */

.active {
    background-color: teal !important;
    color: white;
}

.active td:nth-child(1) {
    color: white;
}

.child {
    background-color: white !important;
    border-left: 4px solid teal;
    border-right: 3px solid teal;
    border-bottom: 2px solid teal;
}

.tableColumnFilter {
    background-color: white;
    border-radius: 4px;
    width: 100%;
    height: 31px;
    color:black;
    padding-left: 15px;
    border: 2px hidden black;
  }
  
.app-toolbar{
    border:1px solid grey;
    position: sticky;
    position: -webkit-sticky; 
    top: 0;
    z-index: 1000;
}

.unitId, .unitMake, .unitModel, .esn, .engineMake, .engineModel{
    width:200px;
}

.unitYear, .engineYear{
    width:130px;
}


/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/customer-email-notification/customer-email-notification.component.css"],"names":[],"mappings":"AAAA;IACI,mFAAmF;IACnF,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,YAAY,EAAE,YAAY;IAC1B,eAAe;AACnB;AACA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;AACA;;;GAGG;;AAEH;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,wBAAwB;EAC1B;;AAEF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA,gmIAAgmI","sourcesContent":[".labelStyle{\r\n    font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; \r\n    font-size: 14px; \r\n    padding-right: 5px;\r\n}\r\n\r\n.inputDate{\r\n    width:140px; \r\n    border-radius:5px;\r\n    border: 1px solid teal; \r\n    height: 30px; color: black;\r\n    font-size: 14px;\r\n}\r\n.table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 10px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 10px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n/* \r\n.first td:nth-child(1) {\r\n    color: teal;\r\n} */\r\n\r\n.active {\r\n    background-color: teal !important;\r\n    color: white;\r\n}\r\n\r\n.active td:nth-child(1) {\r\n    color: white;\r\n}\r\n\r\n.child {\r\n    background-color: white !important;\r\n    border-left: 4px solid teal;\r\n    border-right: 3px solid teal;\r\n    border-bottom: 2px solid teal;\r\n}\r\n\r\n.tableColumnFilter {\r\n    background-color: white;\r\n    border-radius: 4px;\r\n    width: 100%;\r\n    height: 31px;\r\n    color:black;\r\n    padding-left: 15px;\r\n    border: 2px hidden black;\r\n  }\r\n  \r\n.app-toolbar{\r\n    border:1px solid grey;\r\n    position: sticky;\r\n    position: -webkit-sticky; \r\n    top: 0;\r\n    z-index: 1000;\r\n}\r\n\r\n.unitId, .unitMake, .unitModel, .esn, .engineMake, .engineModel{\r\n    width:200px;\r\n}\r\n\r\n.unitYear, .engineYear{\r\n    width:130px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
